angular
  .module('capability-ng-major-explorer')
  .factory('phxDelegateTagConfiguration', function phxDelegateTagConfiguration() {
    return {
      uniqueComponent: 'phx-delegate-tag',
      vocabulary: {
        invoke: function (scope, elem, attrs, event) {
          // eslint-disable-line no-unused-vars
          return _.reduce(attrs.method.split('.'), (acc, prop) => acc[prop], scope)();
        }
      }
    };
  })
  .directive('phxDelegateTag', function (DelegateResponder, phxDelegateTagConfiguration) {
    return {
      scope: false,
      link: DelegateResponder(phxDelegateTagConfiguration, function (scope, element, attrs) {
        // eslint-disable-line no-unused-vars
      })
    };
  })
  .service('phxDelegateTagDelegate', function phxDelegateTagDelegate(DelegateController, phxDelegateTagConfiguration) {
    DelegateController(this, phxDelegateTagConfiguration);
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/phx_delegate_tag/delegate_tag_component.es.js